import type {
  ActionItemType,
  OrganizationType,
  ProjectStats,
  ProjectType,
  TaskType,
  UserType,
} from 'shared/common/global-types.d'
import { isDefined, isObject } from './generics'
import { PROJECT_STATUS } from 'shared/common/enums'

export const isOrganization = <T = OrganizationType>(arg: any): arg is T =>
  isObject(arg) && arg.__typename === 'OrganizationType'

export const isProject = <TType = ProjectType>(arg: any): arg is TType =>
  isObject(arg) && arg.__typename === 'ProjectType'

export const isActiveProject = (arg: any) =>
  isProject(arg) &&
  arg.status !== PROJECT_STATUS.done &&
  arg.status !== PROJECT_STATUS.cancelled

export const isProjectStats = <T = ProjectStats>(arg: any): arg is T =>
  isObject(arg) && arg.__typename === 'ProjectStats'

export const isProjectStatistics = <T = ProjectStats>(arg: any): arg is T => {
  return isObject(arg) && arg.__typename === 'ProjectStats'
}

export const isActionItem = <TType = ActionItemType>(
  node: any,
): node is TType => isObject(node) && node.__typename === 'ActionItemType'

export const isUser = <TType = UserType>(arg: any): arg is TType =>
  isObject(arg) && arg.__typename === 'UserType'

export const isTask = <TType = TaskType>(arg: any): arg is TType =>
  isObject(arg) &&
  (arg.__typename === 'TaskType' || isDefined<TType>(arg.taskType))
